// React
import { FC, useContext } from 'react'

// Libraries
import { useNavigate } from 'react-router-dom'
import { ThemeContext } from 'styled-components'

// Misc
import { buttonClickTracking } from 'utils/tracking'
import { urls } from 'routes/paths'
import useMediaQuery from 'hooks/useMediaQuery'

// Components
import { Aligner, Button } from 'heeds-ds'
import * as Styled from '../styled'

// Assets
import doneAll from 'assets/images/done-all.png'

const SuccessfullyConfirmed: FC = () => {
  const theme = useContext(ThemeContext)
  const navigate = useNavigate()
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.desktop}px)`)

  return (
    <Aligner flex="column">
      <Styled.Image src={doneAll} />
      <Aligner flex="column" align="center" gap={isDesktop ? '4rem' : '2.4rem'}>
        <Styled.TitleMain>Deu tudo certo!</Styled.TitleMain>
        <Styled.SubTitleMain>Seu cadastro foi confirmado.</Styled.SubTitleMain>
      </Aligner>
      <Aligner
        align="center"
        flex="column"
        margin={isDesktop ? '5.6rem 0 0 0' : '5.6rem 0'}
      >
        {!isDesktop && (
          <Button
            onClick={() => window.open('cadu.fit://auth/login')}
            size={isDesktop ? 'small' : 'medium'}
            track={buttonClickTracking}
            trackName="open_app"
          >
            Ir para o aplicativo
          </Button>
        )}

        <Button
          onClick={() => navigate(urls.dashboard)}
          size={isDesktop ? 'small' : 'medium'}
          track={buttonClickTracking}
          trackName="navigate_to_dashboard"
          variation={isDesktop ? 'main' : 'borderless'}
        >
          {isDesktop ? 'Entrar na minha conta' : 'Entrar pelo navegador'}
        </Button>
      </Aligner>
    </Aligner>
  )
}

export default SuccessfullyConfirmed
